import type { ChipProps } from '@mui/material';
import type { FilterState } from '../../../../utils/types/JobOpenings';
import type { JobPostViewMode } from '../interfaces';

export const JOB_POST_PAGE_LIMIT = 12;

export const JOB_POST_VIEW_MODES: JobPostViewMode[] = ['grid', 'list'];

export const DEFAULT_JOB_POST_VIEW_MODE: JobPostViewMode = 'grid';

export const EMPTY_JOB_FILTERS: FilterState = {
  jobTitle: [],
  location: [],
  workType: [],
  department: [],
};

export type WorkTypeChipColor = ChipProps['color'];

export const WORK_TYPE_COLOR_MAP: Record<string, WorkTypeChipColor> = {
  Remote: 'success',
  Office: 'info',
  Hybrid: 'warning',
};

export const LANG_NAMES: Record<string, string> = {
  en: 'English',
  id: 'Indonesian',
  ms: 'Malay',
  zh: '中文 (简)',
  'zh-TW': '中文 (繁)',
  ja: '日本語',
  ko: '한국어',
  th: 'ภาษาไทย',
  vi: 'Tiếng Việt',
  ar: 'عربي',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  pt: 'Português',
  si: 'Sinhala',
  ta: 'Tamil',
  ru: 'Russian',
};

export const GOOGLE_MAPS_SCRIPT_ID = 'google-maps-script';

export const GOOGLE_MAPS_API_SRC =
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyCwgVmtYRMNGry-rv8l91qgW-OfXOaoqCU&libraries=places';
